import React from 'react';
import ShopifyTag from '../../../../shared/ShopifyTag';
import ZapierTag from '../../../../shared/ZapierTag';
import { OrderSource } from '../../../../../types/TOrderSource';

const SOURCE_TAGS: Record<OrderSource, React.FC> = {
  [OrderSource.SHOPIFY]: ShopifyTag,
  [OrderSource.ZAPIER]: ZapierTag,
};

interface OrderSourceTagProps {
  source?: OrderSource;
}

// Rendered in the card's headerAddon slot so the title stays a string and keeps the card's header style.
const OrderSourceTag: React.FC<OrderSourceTagProps> = ({ source }) => {
  const SourceTag = source && SOURCE_TAGS[source];
  return SourceTag ? <SourceTag /> : null;
};

export default OrderSourceTag;
